import { render, staticRenderFns } from "./arrow-next.vue?vue&type=template&id=fb2efdea"
import script from "./arrow-next.vue?vue&type=script&lang=js"
export * from "./arrow-next.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports